import * as React from "react";
import type { SVGProps } from "react";
const SvgImage03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M2.893 19.093a1 1 0 1 0 1.414 1.414L3.6 19.8zM8.4 15l.707-.707a1 1 0 0 0-1.414 0zm2.4 2.4-.707.707a1 1 0 0 0 1.414 0zm5.4-5.4.707-.707a1 1 0 0 0-1.414 0zm4.093 5.507a1 1 0 0 0 1.414-1.414L21 16.8zM3.6 19.8l.707.707 4.8-4.8L8.4 15l-.707-.707-4.8 4.8zM8.4 15l-.707.707 2.4 2.4.707-.707.707-.707-2.4-2.4zm2.4 2.4.707.707 5.4-5.4L16.2 12l-.707-.707-5.4 5.4zm5.4-5.4-.707.707 4.8 4.8L21 16.8l.707-.707-4.8-4.8zM6 2.4v1h12v-2H6zM21.6 6h-1v12h2V6zM18 21.6v-1H6v2h12zM2.4 18h1V6h-2v12zM6 21.6v-1A2.6 2.6 0 0 1 3.4 18h-2A4.6 4.6 0 0 0 6 22.6zM21.6 18h-1a2.6 2.6 0 0 1-2.6 2.6v2a4.6 4.6 0 0 0 4.6-4.6zM18 2.4v1A2.6 2.6 0 0 1 20.6 6h2A4.6 4.6 0 0 0 18 1.4zm-12 0v-1A4.6 4.6 0 0 0 1.4 6h2A2.6 2.6 0 0 1 6 3.4zm3.6 5.4h-1a.8.8 0 0 1-.8.8v2a2.8 2.8 0 0 0 2.8-2.8zM7.8 9.6v-1a.8.8 0 0 1-.8-.8H5a2.8 2.8 0 0 0 2.8 2.8zM6 7.8h1a.8.8 0 0 1 .8-.8V5A2.8 2.8 0 0 0 5 7.8zM7.8 6v1a.8.8 0 0 1 .8.8h2A2.8 2.8 0 0 0 7.8 5z"
    />
  </svg>
);
export default SvgImage03;
